import { SpeciesAiSearchScreen } from '@screens/SpeciesSearch/SpeciesAiSearchScreen/SpeciesAiSearchScreen';

export default function BoardEditReportSpeciesAiScreen(): React.ReactNode {
  return <SpeciesAiSearchScreen />;
}
